import {Box} from 'external/material'
import {GroupIcon} from 'resources/icons'
import useTranslations from 'hooks/translations'

export default function Group({name, showLabel, width, fill, Badge}) {
  const {translate} = useTranslations()
  return (
  <Box className="group">
    {showLabel && <Box className="groupLabel">{translate('group')}</Box>}
    <Box className="groupIcon">
      <GroupIcon width={width || 40} fill={fill || '#809ab3'} />
    </Box>
    <Box className="groupName">
      {Badge && <Badge>{name}</Badge>}
      {!Badge && name}
    </Box>
  </Box>
  )
}
